export interface EcoImgProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc?: string;
    /**
     * 分辨率[1024, 0) 或 (768, 0)
     */
    h5?: string;
    title?: string;
}
export default function EcoImg({ pc, h5, title }: EcoImgProps) {
    return (
        <>
            <picture className="eco-banner-img">
                <source media="(max-width: 1024px)" srcSet={h5} />
                <img src={pc} alt={title} fetchpriority="high" />
            </picture>
        </>
    );
}
